import { StackActions, useNavigation, useRoute } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { TransactionQueryComp } from '../../comps/TransactionQueryComp'
import { useLazyApiData, useStores } from '../../data/store'
import { Screens } from '../../nav/Screens'

export const BalanceEnquiryScreen = () => {
  const { getBalanceApi, getBankId, getConsentDetails } = useStores((root) => ({
    getBalanceApi: root.customer.getBalanceApi,
    getBankId: root.banks.getBankId,
    getConsentDetails: root.consents.getConsentDetails,
  }))
  const navigation = useNavigation()
  const routes = useRoute()
  const [routeData, setRouteData] = useState({})

  const [lazyGetBalance, getBalanceHandler] = useLazyApiData(getBalanceApi)

  const consentDetails = getConsentDetails('CUSTOMER_BI')

  useEffect(() => {
    navigation.setOptions({ headerTitle: 'Balance Enquiry' })
  }, [navigation])

  useEffect(() => {
    if (getBalanceHandler.state === 'fulfilled') {
      const showRetry = getBalanceHandler?.data?.responseCode !== 'WL'
      navigation.dispatch(
        StackActions.replace(Screens.CASH_WITHDRAWAL_STATUS, { ...routeData, showRetry, type: 'balance_enquiry' }),
      )
    }
  }, [getBalanceHandler, navigation, routeData])

  const fetchBalance = ({ bankName, aadhaarNo, mobileNo, fingerprintData, vid, authMode }: any) => {
    setRouteData({
      bankName,
      aadhaarNo,
      mobileNo,
      vid,
      bankId: getBankId(bankName, 'CUSTOMER_BI'),
      consentDetails,
      authMode,
      activityType: 'CUSTOMER_BI',
    })
    lazyGetBalance(
      aadhaarNo,
      getBankId(bankName, 'CUSTOMER_BI'),
      bankName,
      mobileNo,
      fingerprintData,
      vid,
      consentDetails,
      authMode,
    )
  }

  return (
    <>
      <TransactionQueryComp
        onSubmit={fetchBalance}
        isLoading={getBalanceHandler.state === 'pending'}
        shouldShowLinkAadhaarDialog={
          getBalanceHandler.state === 'rejected' && getBalanceHandler?.data?.data?.responseCode === '22413'
        }
        params={{ ...(routes?.params ?? {}) }}
        activityType="CUSTOMER_BI"
      />
    </>
  )
}
